import { trpc } from '@/shared/api';
import { usePresignedImageUpload } from '@/shared/lib';

/** 기업 고객 사례 사진 업로드 — 발급(landing.presignTestimonialUpload) → S3 직접 PUT. */
export const useLandingTestimonialUpload = () => {
  const presignMutation = trpc.landing.presignTestimonialUpload.useMutation();

  return usePresignedImageUpload((contentType) => presignMutation.mutateAsync({ contentType }));
};
